import { ProjectService } from '@/core/Services'
import { Storage } from "@/core/Utils";

export default {
    getMessages() {
      ProjectService.getEnglishProjectMessages().then(response => {
          Storage.setProjectMessages(response.messages);
      }).catch(err => {
          // TODO: handle error
      })
    },
};
